import axios from "axios";

// API call using Axios package 
export default axios.create({
    baseURL:"https://fakestoreapi.com",
})